"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.PermissionSchema = joi_1.default.object({
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    apiKey: joi_1.default.string().required(),
    description: joi_1.default.string(),
    organizationUuid: joi_1.default.string().uuid().required(),
    uuid: joi_1.default.string().uuid().required(),
    values: joi_1.default.array().items(joi_1.default.string()).required()
}).meta({ className: 'Permission' });
//# sourceMappingURL=PermissionSchema.js.map